import mapKeys from 'lodash/mapKeys'
import omitBy from 'lodash/omitBy'

import { getNextLimit } from 'Global/Helpers/appHelpers'

import {
  FILTERS_NAME_SET,
  FORM_NAME_SET,
  LAYOUT_TOGGLE,
  LIMIT_TOGGLE,
  PAGE_SET,
  SEARCHES_GET_FULFILLED,
  SEARCHES_GET_PENDING,
  SEARCHES_GET_REJECTED,
  SEARCH_DELETE_FULFILLED,
  SORT_BY_SET,
  SORT_ORDER_TOGGLE,
} from './actionTypes'

import { SEARCH_SAVE_FULFILLED } from 'Modules/SearchModule/actionTypes'

const initialState = {
  filters: {
    name: '',
  },
  form: {
    name: '',
  },
  layout: 'gridLayout',
  limit: 36,
  page: 1,
  searches: {
    data: [],
    done: false,
    error: false,
    pending: false,
  },
  sortBy: 'name',
  sortOrder: 'ascending',
}

const reducer = (state = initialState, action) => {
  const { payload, type } = action

  switch (type) {
    case FILTERS_NAME_SET:
      return {
        ...state,
        filters: {
          ...state.filters,
          name: payload,
        },
      }

    case FORM_NAME_SET:
      return {
        ...state,
        form: {
          ...state.form,
          name: payload,
        },
      }

    case LAYOUT_TOGGLE:
      if (state.layout === 'gridLayout') {
        return {
          ...state,
          layout: 'tableLayout',
        }
      }

      if (state.layout === 'tableLayout') {
        return {
          ...state,
          layout: 'gridLayout',
        }
      }

      return state

    case LIMIT_TOGGLE:
      return {
        ...state,
        limit: getNextLimit(state.limit),
      }

    case PAGE_SET:
      return {
        ...state,
        page: payload,
      }

    case SEARCHES_GET_FULFILLED:
      return {
        ...state,
        searches: {
          ...state.searches,
          data: mapKeys(payload.data, 'id'),
          done: true,
          error: false,
          pending: false,
        },
      }

    case SEARCHES_GET_PENDING:
      return {
        ...state,
        searches: {
          ...state.searches,
          error: false,
          pending: true,
        },
      }

    case SEARCHES_GET_REJECTED:
      return {
        ...state,
        searches: {
          ...state.searches,
          done: true,
          error: true,
          pending: false,
        },
      }

    case SEARCH_DELETE_FULFILLED:
      return {
        ...state,
        searches: {
          ...state.searches,
          data: omitBy(state.searches.data, i => i.id === parseInt(payload.data, 10)),
        },
      }

    case SORT_BY_SET:
      return {
        ...state,
        sortBy: payload,
      }

    case SORT_ORDER_TOGGLE:
      if (state.sortOrder === 'ascending') {
        return {
          ...state,
          sortOrder: 'descending',
        }
      } else {
        return {
          ...state,
          sortOrder: 'ascending',
        }
      }

    case SEARCH_SAVE_FULFILLED:
      return {
        ...state,
        searches: {
          ...state.searches,
          data: {
            ...state.searches.data,
            [payload.data.id]: payload.data,
          },
        },
      }

    default:
      return state
  }
}

export default reducer
